import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { APP_ENV } from '../config/app-environment';
import { I18nService } from '../i18n/i18n.service';
import { AuthService } from './auth.service';

export const authTokenInterceptor: HttpInterceptorFn = (request, next) => {
  const environment = inject(APP_ENV);
  const authService = inject(AuthService);
  const i18n = inject(I18nService);

  if (!request.url.startsWith(environment.apiBaseUrl)) {
    return next(request);
  }

  return from(authService.ensureValidToken()).pipe(
    switchMap((token) => {
      const headers: Record<string, string> = {
        'Accept-Language': i18n.language()
      };

      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }

      return next(
        request.clone({
          setHeaders: headers
        })
      );
    })
  );
};
